import type { PageCard } from '@/play/pageTypes'
import { FlowingMetalCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'flowing-metal',
  number: 7,
  title: 'Liquid metal',
  question: 'How fluid should liquid metal feel? A tuning page for its shape, surface and wobble.',
  status: 'open',
  accent: '#c9d1da',
  CardArt: FlowingMetalCardArt,
}
